import { Badge, createDateColumn, createTextColumn, useGenericListConfig } from '@pesto/ui';

import type { UserTransactionListItem } from './toUserTransactionListItem';

const ledgerOnlyColumn = {
  id: 'ledgerOnly',
  header: '',
  enableSorting: false,
  cell: ({ row }: { row: { original: UserTransactionListItem } }) =>
    row.original.ledgerOnly ? (
      <Badge variant="secondary" className="text-[10px] uppercase">
        Ledger only
      </Badge>
    ) : null,
};

export const useUserTransactionsListConfig = () => {
  const columns = [
    createDateColumn<UserTransactionListItem>('effectiveDate', 'Posted', (row) => row.effectiveDate, {
      dateFormat: 'd MMM yyyy',
    }),
    createTextColumn<UserTransactionListItem>('merchantName', 'Description', (row) => row.merchantName),
    createTextColumn<UserTransactionListItem>('merchantLocation', 'Location', (row) => row.merchantLocation),
    createTextColumn<UserTransactionListItem>('amount', 'Amount', (row) => row.amount),
    createTextColumn<UserTransactionListItem>('direction', 'Direction', (row) => row.direction),
    createTextColumn<UserTransactionListItem>('transactionType', 'Type', (row) => row.transactionType),
    createTextColumn<UserTransactionListItem>('status', 'Status', (row) => row.status),
    ledgerOnlyColumn,
  ];

  return useGenericListConfig<UserTransactionListItem>({
    columns,
    defaultSorting: [{ id: 'effectiveDate', desc: true }],
  });
};
